import { render, staticRenderFns } from "./RewardRuleMiniApp.vue?vue&type=template&id=cdf71ffe"
import script from "./RewardRuleMiniApp.vue?vue&type=script&lang=js"
export * from "./RewardRuleMiniApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports